import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Dropdown, Avatar,
} from 'antd';
import {
  UserOutlined, LoginOutlined, LogoutOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import  logo from '../../assets/logo-min.png'
import { resolveMedia } from '../../utils/media';

const Header = styled.header.attrs({
  className: 'w-full flex justify-end items-center',
})`
  z-index: 1000;
  position: sticky;
  top: 0;
  height: 70px;
  padding: 0 16px;
  background: ${props => props.theme.colors.header.background};
  border-bottom: 1px solid ${props => props.theme.colors.header.border};
  font-family: 'Source Sans 3', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: -140px; /* Ajusta según quieras separarlo del borde superior */
    right: -70px; /* Ajusta según quieras separarlo del borde derecho */
    width: 250px; /* Tamaño del logo */
    height: 300px; /* Tamaño del logo */
    background-image: url(${logo}); /* Coloca la ruta de tu logo */
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.4; /* Opacidad para efecto de marca de agua */
    pointer-events: none; /* Para que no interfiera con clicks */
  }
`;

const Title = styled.h2.attrs({
  className: 'ml-4',
})`
`;

const HeaderRight = styled.nav`
  margin-left:auto;
  display:inline-flex;

  & > i, & > span {
    margin: 0 10px;
  }
`;

const DashboardHeader = ({ title }) => {
  const navigate = useNavigate();
  const { logout, isAuthenticated, user } = useAuth();
  const { colors } = useTheme();
  const nickname = `${user?.firstName} ${user?.lastName} ${user?.secondLastName || ''}` || user?.nickname || user?.email;
  const role = user?.role?.name || '';
  const picture = resolveMedia(user?.photoUrl);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'account',
      icon: <UserOutlined />,
      label: 'Inicio',
      onClick: () => navigate('/account/info'),
    },
    {
      type: 'divider',
    },
    ...(!isAuthenticated
      ? [
          {
            key: 'login',
            icon: <LoginOutlined />,
            label: 'Iniciar sesión',
            onClick: () => navigate('/login'),
          },
        ]
      : [
          {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Cerrar sesión',
            onClick: handleLogout,
          },
        ]),
  ];

  return (
    <Header className="cursor-pointer">
      <Title style={{ fontFamily: 'Source Sans 3', fontWeight: 600, fontSize: 16, color: colors.header.text }}>{title}</Title>
      <HeaderRight>
        <Dropdown className="ml-4 mr-4" menu={{ items: menuItems }}>
          <div>
             <Avatar
              src={picture || undefined}
              style={{
                marginRight: 5,
                border: `2px solid ${colors.header.text}`,
                boxSizing: 'border-box',
              }}
              size="large"
              icon={picture ? undefined : <UserOutlined />}
            />
            <span className="text-xs" style={{ fontFamily: 'Source Sans 3', fontWeight: 500, fontSize: 16, color: colors.header.text }}>{nickname}</span>
            <br></br>
            <span className="text-xs" style={{ fontFamily: 'Source Sans 3', fontWeight: 500, fontSize: 16, color: colors.header.text }}>{role}</span>
            <i className="fa-solid fa-chevron-down" style={{ color: colors.header.text, fontSize: 14, paddingRight: 3, paddingLeft: 9 }} />
          </div>
        </Dropdown>
      </HeaderRight>
    </Header>
  );
};

export default memo(DashboardHeader);
